<template>
    <div id="myDIV" class="container m-5 pt-5">
        <div class="d-flex justify-content-center align-items-end">
            <img class="fondo imge" src="/metaHorizontalAzul.png" alt="">
        </div>
        <div class="row  justify-content-center mt-5">
            <div class="col-sm-8 col-12  div__title d-flex align-items-center justify-content-center">
                <h3>Política de privacidad</h3>
            </div>
        </div>
        <div class="row  justify-content-center">
            <div class="col-sm-8 col-12 my-4">
                <p>De acuerdo a lo previsto en la Ley Federal de Protección de Datos Personales en Posesión de los
                    Particulares Mexicana de Técnicos en Autopistas S.A. de C.V. declara ser una empresa legalmente
                    constituida de conformidad con las leyes mexicanas, con domicilio ubicado en Libramiento Oriente
                    Km 11 +200 San Nicolas de los Jassos, CP. 78420 San Luis Potosí, SLP, país México así como
                    manifestar ser la responsable del tratamiento de sus datos personales.</p>
                <p>
                    La oficina de privacidad de sus datos personales se encuentra ubicada en mismo domicilio señalado
                    y el teléfono de la oficina de privacidad es 444 5007222, metaslp.facturas@valoran.com.mx
                </p>
                <p>Definiciones</p>
                <p>Datos personales Cualquier información concerniente a una persona física identificada o
                    identificable.
                    Titular La persona física (TITULAR) a quien identifica o corresponden los datos personales.
                    Responsable Persona física o moral de carácter privado que decide sobre el tratamiento de los
                    datos personales. Tratamiento La obtención, uso (que incluye el acceso, manejo, aprovechamiento,
                    transferencia o disposición de datos personales), divulgación o almacenamiento de datos personales
                    por cualquier medio. Transferencia Toda comunicación de datos realizada a persona distinta del
                    responsable o encargado del tratamiento. Derechos ARCO Derechos de acceso, rectificación,
                    cancelación y oposición. LFPDPPP Ley Federal de Protección de Datos Personales en Posesión de
                    los Particulares. Consemiento tácito Se entenderá que el titular ha consentido en el tratamiento de
                    los
                    datos, cuando habiéndose puesto a su disposición el Aviso de Privacidad, no manifieste su oposición.
                    Fines de la información Sus datos personales serán utilizados para fines económicos, bancarios y de
                    marketing. Formas de recabar sus datos personales Para las actividades señaladas en el presente
                    aviso de privacidad, podemos recabar sus datos personales de distintas formas, cuando usted nos
                    los proporciona directamente; cuando visita nuestro sitio de Internet o utiliza nuestros servicios
                    en
                    línea, y cuando obtenemos información a través de otras fuentes que están permitidas por la ley. De
                    igual forma como parte de su información personal, Mexicana de Técnicos en Autopistas S.A. de
                    C.V. puede obtener audio y video al momento que usted ingresa en nuestras instalaciones ello con
                    fines específicos de seguridad. Datos personales que se recaban de forma directa Recabamos sus
                    datos personales de forma directa cuando usted mismo nos los proporciona o por diversos medios
                    permitidos por la ley, tales como:</p>
                <ul>
                    <li>Correo electrónico</li>
                    <li>Nombre completo</li>
                    <li>Genero</li>
                    <li>Nacionalidad</li>
                    <li>Estado civil</li>
                    <li>Teléfono</li>
                    <li>Teléfono móvil</li>
                    <li>Domicilio</li>
                    <li>Datos financieros</li>
                    <li>RFC</li>
                    <li>Imágenes de videograbadas y ocasionalmente audio</li>
                    <li>Registro Patronal</li>
                    <li>Escolaridad</li>
                    <li>Estado Civil</li>
                    <li>Nombre y lugar donde labora</li>
                </ul>
                <p>
                    Datos personales que recabamos cuando visita nuestro sitio de internet o utiliza nuestros servicios
                    en línea Recabamos sus datos personales cuando visita nuestro sitio de internet o utiliza nuestros
                    servicios en línea; tales como:
                </p>
                <ul>
                    <li>Correo electrónico</li>
                    <li>Nombre completo</li>
                    <li>Genero</li>
                    <li>Nacionalidad</li>
                    <li>Estado civil</li>
                    <li>Teléfono</li>
                    <li>Teléfono móvil</li>
                    <li>Domicilio</li>
                    <li>Datos financieros</li>
                    <li>RFC</li>
                    <li>Datos personales que recabamos a través de otras fuentes permitidas por la ley</li>
                    <li>Correo electrónico</li>
                    <li>Nombre completo</li>
                    <li>Genero</li>
                    <li>Nacionalidad</li>
                    <li>Estado civil</li>
                    <li>Teléfono</li>
                    <li>Teléfono móvil</li>
                    <li>Domicilio</li>
                    <li>Datos financieros</li>
                    <li>RFC</li>
                </ul>
                <p>Uso de datos sensibles Se consideran datos sensibles aquellos afecten a la esfera más íntima de su
                    titular, o cuya utilización indebida pueda dar origen a discriminación o conlleve un riesgo grave
                    para éste,
                    en el presente aviso de privacidad se omite el uso de datos personales considerados como sensibles
                    toda vez que nosotros NO recabamos datos sensibles, con excepción de imágenes videograbadas
                    para fines de seguridad. Limitación o divulgación de sus datos personales El responsable de la
                    información se compromete a realizar únicamente las siguientes acciones, respecto a su información:
                    *enviar correos electrónicos * llamadas telefónicas * datos para notarias públicas *datos para
                    registro
                    publico *datos para instituciones financieras Entre otros En consecuencia el tratamiento de sus
                    datos
                    personales se imita al cumplimiento de las finalidades especificadas según lo dispuesto por el
                    artículo
                    12 LFPDPPP. Medios para limitar el uso o divulgación de datos Mexicana de Técnicos en Autopistas
                    S.A. de C.V. cuenta con certificado por lo que la información que usted proporciona en nuestra
                    página
                    de internet se encuentra debidamente protegida; así mismo contamos con los mecanismos y medidas
                    de seguridad administrativas, técnicas y físicas para proteger los datos personales del titular
                    contra
                    daño, pérdida, alteración, destrucción o el uso, acceso o tratamiento no autorizado, en términos del
                    artículo 19 LFPDPPP. Mexicana de Técnicos en Autopistas S.A. de C.V. comparte la responsabilidad
                    del cuidado de la información con sus empleados, haciéndolos copartícipes de los lineamientos
                    expuestos en el presente aviso de privacidad. Procedimiento para hacer valer los derechos ARCO </p>
                <p>
                    Usted tiene derecho de acceder a sus datos personales que poseemos y a los detalles del tratamiento
                    de los mismos, así como a rectificarlos en caso de ser inexactos o incompletos; cancelarlos cuando
                    considere que no se requieren para alguna de las finalidades señalados en el presente aviso de
                    privacidad, estén siendo utilizados para finalidades no consentidas o haya finalizado la relación
                    contractual o de servicio, o bien, oponerse al tratamiento de los mismos para fines específicos. Los
                    mecanismos que se han implementado para el ejercicio de dichos derechos, los cuales se conocen
                    como derechos Arco:
                    El procedimiento inicia con la presentación de la solicitud respectiva a los derechos Arco, en el
                    domicilio de nuestra Oficina de Privacidad, mismo que fue debidamente señalado al principio del
                    presente aviso de privacidad.
                </p>
                <p>
                    Su solicitud deberá contener la siguiente información: Nombre del titular de los datos personales,
                    Domicilio o cualquier otro medio de contacto, Documentos que acrediten su personalidad e identidad,
                    La descripción clara y precisa de los datos personales. Cualquier otro documento que facilite la
                    localización de los datos.
                </p>
                <p>
                    El plazo para atender su solicitud es de 20 días contados a partir de la recepción de su solicitud.
                </p>
                <p>
                    Transmisión de sus datos personales Mexicana de Técnicos en Autopistas S.A. de C.V. No requiere
                    transmitir o transferir sus datos personales dentro o fuera del país por lo que su información no
                    puede ser compartida en estos casos, en consecuencia no requerimos de su autorización para
                    ello. Consentimiento de uso de sus datos personales El titular de los datos personales consiente
                    tácitamente en el tratamiento y uso de sus datos personales para los fines y usos que han quedado
                    expresados en el presente aviso de privacidad mismo que ha sido puesto a su disposición, con
                    excepción de la información financiera en cuyo caso Mexicana de Técnicos en Autopistas S.A. de
                    C.V. deberá recabar su consentimiento expreso por escrito en términos de lo establecido por el
                    articulo 8 LFPDPPP. Modificaciones al aviso de privacidad Nos reservamos el derecho de efectuar
                    en cualquier momento modificaciones o actualizaciones al presente aviso de privacidad, para la
                    atención de novedades legislativas, políticas internas o nuevos requerimientos para la prestación u
                    ofrecimiento de nuestros servicios o productos. Por lo que Mexicana de Técnicos en Autopistas S.A.
                    de C.V. se obliga a mantener actualizado el presente aviso, para su consulta. Esto con el fin de que
                    el
                    titular se encuentre en posibilidad de ejercer sus derechos ARCO y de esta forma mantenerlo al tanto
                    de cualquier modificación mediante aviso al último correo electrónico que nos haya proporcionado.
                    Uso de cookies y web beacons En el presente aviso de privacidad se omitirá el uso de COOKIES y
                    WEB BEACONS para recabar información sobre usted. Las partes expresan que el presente aviso,
                    se regirá por las disposiciones legales aplicables en el Estado de San Luis Potosí, en especial, por
                    lo
                    dispuesto en la Ley Federal de Protección de Datos Personales. Si usted considera que su derecho
                    de protección de datos personales ha sido lesionado por alguna conducta de nuestros empleados o
                    de nuestras actuaciones o respuestas, presume que en el tratamiento de sus datos personales existe
                    alguna violación a las disposiciones previstas en la Ley Federal de Protección de Datos Personales
                    en Posesión de los Particulares, podrá interponer la queja o denuncia correspondiente ante el IFAI.
                </p>
            </div>
        </div>
        <div class="d-flex justify-content-center align-items-end">
            <img class="fondo2 imge" src="/metaLogoAzul.png" alt="">
        </div>
    </div>
</template>

<script>
const body = document.getElementsByTagName("body")[0];
export default {
    name: "politica",
    mounted() {
        const miDiv = document.getElementById('myDIV');
        miDiv.scrollIntoView();
    },
    created() {
        this.$store.state.hideConfigButton = true;
        this.$store.state.showNavbar = false;
        this.$store.state.showSidenav = false;
        this.$store.state.showFooter = false;
        body.classList.remove("bg-gray-100");
    },
    beforeUnmount() {
        this.$store.state.hideConfigButton = false;
        this.$store.state.showNavbar = true;
        this.$store.state.showSidenav = true;
        this.$store.state.showFooter = true;
        body.classList.add("bg-gray-100");
    },
};
</script>

<style lang="scss" scoped>
$primaryColor: #0153a2;

.div__title {
    border-bottom-style: solid;
    border-bottom-color: $primaryColor;
}

img {
    width: 30px;
}

.fondo {
    width: 33%;
    top: 90%;
    margin-left: 2%;
}

.fondo2 {
    width: 5%;
    top: 20%;
    margin-left: 2%;
}
</style>